import {ChangeDetectionStrategy, Component, ElementRef, Input, ViewChild} from '@angular/core';
import {ReactBaseComponent} from '../../react/base/react-base.component';
import {EvStatusLabel, EvStatusLabelType} from '../../react/components/labels/ev-status-label';

const containerElementName = 'reactEvStatusLabel';

@Component({
  selector: 'ev-status-label',
  template: `<div class="inline m-0! p-0!" #${containerElementName}></div>`,
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: true,
})
export class EvStatusLabelComponent extends ReactBaseComponent {
  @ViewChild(containerElementName, {static: false}) containerRef: ElementRef;
  @Input() type: EvStatusLabelType;
  @Input() state?: string | number | null;
  @Input() clazz?: string;
  @Input() additional?: string | null;

  constructor() {
    super();
  }

  protected renderComponent() {
    return <EvStatusLabel type={this.type}
                          state={this.state}
                          additional={this.additional}
                          className={this.clazz}/>;
  }
}
